module.exports = __webpack_public_path__ + "static/media/muncipal_tax.6a74d102.png";